export default __webpack_public_path__ + "static/media/quick_play_care_package.6882987c.svg";